<template>
	<div>
		<span class="is-size-5-mobile is-size-4-tablet medium-text">{{ `${plan.leads_amount} Verified Jobs` }}</span>
		<span class="is-size-6-mobile is-size-5-tablet"><br/>for<br/></span>
		<span class="is-size-5-mobile is-size-4-tablet medium-text">{{ priceFormatter(plan.price) }}</span>
		<span><br/>({{priceFormatter(plan.price_per_lead)}}/lead)</span>
	</div>
</template>
<script lang="ts">
import { LeadsPlanContentMixin } from "@/utils/mixins";
import { funnelsUtilsServices } from "@puls/puls-general-utils";
import { defineComponent } from "vue";

export default defineComponent({
	mixins: [LeadsPlanContentMixin],
	data () {
		return {
			priceFormatter: funnelsUtilsServices.priceFormatter
		}
	}
})
</script>

<style scoped>
    
</style>
